import { Injectable } from "@angular/core";
import { select } from "@ngneat/elf";

import { ChecklistProgressStateStore } from "./checklist-progress-state.store";

@Injectable({ providedIn: "root" })
export class ChecklistProgressStateQuery {
	constructor(private checklistProgressStateStore: ChecklistProgressStateStore) {}

	checklist$ = this.checklistProgressStateStore.store.pipe(select((state) => state.checklist));
	responses$ = this.checklistProgressStateStore.store.pipe(select((state) => state.responses));
}
